
const getCookie = function(cookieName) {
    // Split the cookie string into an array of key-value pairs
    const cookies = document.cookie.split(';');

    // Loop through the array to find the cookie with the specified name
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        // If the cookie is found, return its value
        if (cookie.startsWith(cookieName + '=')) {
            return cookie.substring(cookieName.length + 1);
        }
    }

    // If the cookie is not found, return null
    return null;
}

const setCookie = function(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const setLocaleCookie = function(locale) {
    let lifetime = 60*60*24*30 // 30 days
    let cookieString = "locale="+ locale +";path=/;max-age=" + lifetime
    document.cookie = cookieString

    setLocaleStorage(locale)
}

const setLocaleStorage = function(locale) {
    localStorage.setItem('locale', locale)
}

export { setCookie, getCookie, setLocaleCookie }